import type { FC } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ProductThumbnail,
  Text
} from '@cencosud-cencommerce/paris-uikit';

interface DeleteCartItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  product?: {
    name: string;
    imageUrl: string;
  };
  loading?: boolean;
}
const DeleteCartItemModal: FC<DeleteCartItemModalProps> = ({
  isOpen,
  onClose,
  onDelete,
  product,
  loading
}) => {
  if (!product) {
    return null;
  }

  return (
    <Modal size="sm" isOpen={isOpen}>
      <ModalHeader
        className="[&_h3]:co-text-[0.875rem] tablet:[&_h3]:co-text-[1.25rem]"
        onClose={onClose}
        icon={{ name: 'info-circle', fill: 'primary-500' }}
        title="¿Quieres eliminar este producto?"
      />
      <ModalBody className="co-flex co-flex-col co-p-6 co-gap-4 co-mb-0 co-mt-0">
        <div>
          <div className="co-flex co-gap-3 co-p-3 co-items-center co-mb-2">
            <ProductThumbnail
              variant="default"
              alt={product.name}
              src={product.imageUrl}
            />
            <Text variant="body2" weight={700} fixed>
              {product.name}
            </Text>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="co-flex co-flex-col-reverse tablet:co-flex-row co-justify-end co-gap-2 [&>*]:co-w-full tablet:[&>*]:co-w-fit">
        <Button block size="xl" variant="secondary" onClick={onClose}>
          Volver
        </Button>
        <Button
          size="xl"
          variant="primary"
          onClick={onDelete}
          loading={loading}
        >
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteCartItemModal;
